import { PagedResponse } from 'app/interfaces/paged-response.inteface';
import { Injectable } from "@angular/core";
import { Terminal } from "@tivic-team/manager-ts/dist/mob/entities/terminal/terminal.entity";
import { TerminalController } from "app/controllers/mob/terminal.controller";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { TerminalSearch } from "./terminal.search";

@Injectable({
  providedIn: "root",
})

export class TerminalService implements ApiService<Terminal>{

  constructor(
    private _terminalController: TerminalController,
    private _loaderService: LoaderService
  ) { }

  find(search?: TerminalSearch): Promise<Terminal[]> {
    this._loaderService.show();
    return this._terminalController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  get(cdTerminal: number): Promise<Terminal> {
    this._loaderService.show();
    return this._terminalController.get(cdTerminal).finally(() => this._loaderService.hide());
  }

  save(entity: Terminal): Promise<Terminal> {
    if (!entity.cdTerminal)
      return this.create(entity);
    return this.update(entity);
  }

  create(entity: Terminal): Promise<Terminal> {
    this._loaderService.show();
    return this._terminalController.create(entity).finally(() => this._loaderService.hide());
  }

  update(entity: Terminal): Promise<Terminal> {
    this._loaderService.show();
    return this._terminalController.update(entity).finally(() => this._loaderService.hide());
  }

  findTerminal(search?: TerminalSearch): Promise<PagedResponse<Terminal>>{
    this._loaderService.show();
    return this._terminalController.findTerminal(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }
}
